import { render, staticRenderFns } from "./StudentFinancial.vue?vue&type=template&id=18b4d114&scoped=true&"
import script from "./StudentFinancial.vue?vue&type=script&lang=js&"
export * from "./StudentFinancial.vue?vue&type=script&lang=js&"
import style0 from "./StudentFinancial.vue?vue&type=style&index=0&id=18b4d114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4d114",
  null
  
)

export default component.exports